<template>
  <v-app id="vuetify-app">
    <v-tabs icons-and-text v-model="selectedTab" slider-color="success">
      <v-tab :key="'discount-code'">
        {{ 'app.discount_codes.discount_codes' | trans }}
      </v-tab>
      <v-tab :key="'discount-code-usages'">
        {{ 'app.discount_codes.discount_code_usages' | trans }}
      </v-tab>
      <v-tab-item :key="'discount-code'">
        <div>
          <v-flex xs3 class="mb-3">
            <manage-discount-code-modal
              :users="users"
              :roles="roles"
              :subscriptions="subscriptions"
              ref="discountCodeModal"
            />
          </v-flex>
          <discount-code-table @edit-discount-code="editDiscountCode" @view-discount-code="openDiscountCode" />
        </div>
      </v-tab-item>
      <v-tab-item :key="'discount-code-usages'">
        <div>
          <v-flex xs12 class="mb-3">
            <div>
            <discount-code-usages :discount-code-usages="discountCodeUsages"/>
            </div>
          </v-flex>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>

<script>
import {MODE} from "./mode/mode";

export default {
  props: {
    users: Array,
    roles: Array,
    subscriptions: Array,
    discountCodeUsages: Array,
  },
  data: function () {
    return {
      selectedTab: null,
    };
  },
  methods: {
    editDiscountCode(discountCode) {
      this.$refs.discountCodeModal.openAndEdit(discountCode, MODE.EDIT);
    },
    openDiscountCode(discountCode) {
      this.$refs.discountCodeModal.openAndEdit(discountCode, MODE.VIEW);
    },
  },
};
</script>

<style scoped></style>
